var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8498 12.6035C10.5939 13.6862 8.95858 14.3407 7.17037 14.3407C3.21028 14.3407 0 11.1305 0 7.17037C0 3.21029 3.21028 0 7.17037 0C11.1305 0 14.3407 3.21029 14.3407 7.17037C14.3407 8.95832 13.6863 10.5934 12.604 11.8492L15.8438 15.0891C16.0521 15.2973 16.0521 15.635 15.8438 15.8433C15.6355 16.0516 15.2979 16.0516 15.0896 15.8433L11.8498 12.6035ZM1.06667 7.17037C1.06667 3.79939 3.79939 1.06667 7.17037 1.06667C10.5414 1.06667 13.2741 3.79939 13.2741 7.17037C13.2741 8.82309 12.6172 10.3224 11.5503 11.4214C11.5259 11.4387 11.5026 11.4583 11.4807 11.4802C11.4588 11.5021 11.4392 11.5254 11.4219 11.5498C10.3228 12.617 8.82333 13.2741 7.17037 13.2741C3.79939 13.2741 1.06667 10.5414 1.06667 7.17037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.a27019c9212c36cb3ae5d7267b0e4e80.svg";
export { ForwardRef as ReactComponent };